import gql from "graphql-tag";
import { CUSTOMER_APPLICATION_FIELDS } from "./fragments";

export const customerApplicationQuery = gql`
  query customerApplication($id: ID!) {
    customerApplication(id: $id) {
      ...CustomerApplicationFields
    }
  }
  ${CUSTOMER_APPLICATION_FIELDS}
`;

export const newNoticesAddDataQuery = gql`
  query newNoticesAddDataQuery {
    regions {
      id
      name
    }
    storages {
      id
      name
    }
    allManagers {
      id
      name
    }
  }
`;

export const bonusProgramLevelsQuery = gql`
  query bonusProgramLevelsQuery {
    bonusProgramLevels {
      id
      name
    }
  }
`;

export const accessGroupsQuery = gql`
  query accessGroupsQuery {
    accessGroups {
      id
      name
    }
  }
`;

export const rolesQuery = gql`
  query rolesQuery {
    roles {
      id
      name
      code
      parent {
        code
      }
    }
  }
`;

export const regionsManagersAndUtmOptionsQuery = gql`
  query regionsManagersAndUtmOptionsQuery {
    regions {
      id
      name
    }
    dealershipApplicationFilterManagers {
      id
      name
    }
    dealershipApplicationFilterUtmSources
    dealershipApplicationFilterUtmCampaigns
    dealershipApplicationFilterUtmMediums
  }
`;
